import { useState } from "react";
import { Link } from "react-router-dom";
import { LogOut, ExternalLink, Inbox, ShoppingBag, BarChart3, UtensilsCrossed } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import InquiriesTab from "./InquiriesTab";
import CartsTab from "./CartsTab";
import AnalyticsTab from "./AnalyticsTab";
import MenuTab from "./MenuTab";

const TABS = [
  { id: "visitors", label: "Visitors", icon: BarChart3, testid: "tab-visitors" },
  { id: "inquiries", label: "Inquiries", icon: Inbox, testid: "tab-inquiries" },
  { id: "carts", label: "Carts", icon: ShoppingBag, testid: "tab-carts" },
  { id: "menu", label: "Menu", icon: UtensilsCrossed, testid: "tab-menu" },
];

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  const [tab, setTab] = useState("visitors");

  return (
    <div className="min-h-screen bg-nosh-surface" data-testid="admin-dashboard">
      <header className="border-b border-nosh-gold/20 bg-nosh-green">
        <div className="mx-auto flex max-w-[1300px] items-center justify-between px-5 py-3 md:px-8">
          <div className="flex items-center gap-3">
            <span className="grid place-items-center rounded-full bg-nosh-cream p-0.5 ring-1 ring-nosh-gold/40">
              <img src="/nosh-logo.png" alt="Nosh" className="h-11 w-11 object-contain" />
            </span>
            <div className="leading-tight">
              <div className="font-display text-xl font-bold text-nosh-cream">Admin Portal</div>
              <div className="font-poster text-[10px] uppercase tracking-widest text-nosh-gold">{user?.email}</div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Link to="/" className="hidden items-center gap-1.5 rounded-full border border-nosh-cream/30 px-4 py-2 font-poster text-[11px] font-bold uppercase tracking-wide text-nosh-cream transition-colors hover:border-nosh-gold hover:text-nosh-gold sm:flex" data-testid="admin-view-site">
              <ExternalLink className="h-3.5 w-3.5" /> View site
            </Link>
            <button onClick={logout} className="flex items-center gap-2 rounded-full bg-nosh-gold px-4 py-2 font-poster text-[11px] font-bold uppercase tracking-wide text-nosh-ink transition-transform hover:-translate-y-0.5" data-testid="admin-logout">
              <LogOut className="h-4 w-4" /> Logout
            </button>
          </div>
        </div>
        {/* Tabs */}
        <div className="mx-auto max-w-[1300px] px-5 md:px-8">
          <div className="flex gap-1 overflow-x-auto">
            {TABS.map((t) => {
              const Icon = t.icon;
              const active = tab === t.id;
              return (
                <button
                  key={t.id}
                  data-testid={t.testid}
                  onClick={() => setTab(t.id)}
                  className={`flex items-center gap-2 whitespace-nowrap border-b-2 px-4 py-3 font-poster text-[12px] font-bold uppercase tracking-wide transition-colors ${
                    active ? "border-nosh-gold text-nosh-cream" : "border-transparent text-nosh-cream/60 hover:text-nosh-cream"
                  }`}
                >
                  <Icon className="h-4 w-4" /> {t.label}
                </button>
              );
            })}
          </div>
        </div>
      </header>

      <div className="mx-auto max-w-[1300px] px-5 py-8 md:px-8">
        {tab === "visitors" && <AnalyticsTab />}
        {tab === "inquiries" && <InquiriesTab />}
        {tab === "carts" && <CartsTab />}
        {tab === "menu" && <MenuTab />}
      </div>
    </div>
  );
}
